<template>
  <section id="features" class="services">
    <div class="container">
      <div class="text-center p-4">
        <!-- <p>#Blogs | #ShowCases</p> -->
        <h2>Pinnacle of Analytics - Case Studies & Projects</h2>
      </div>

      <div class="row pt-4">
        <div
          class="col-lg-4 col-md-6 col-12 d-flex align-items-stretch"
          v-for="(obj, key) in featureareaJSON"
          :key="key"
        >
          <div class="icon-box" @click.prevent="$router.push(obj.link)">
            <Image :fpath="obj.path" class="serviceimage" />
            <p class="d-flex">
              <span class="category">{{ obj.category }}</span>
              <span class="dot"> . </span>
              <span class="readtime">5 min read</span>
            </p>
            <h4 class="softwarehead">{{ obj.header }}</h4>
            <h6 class="softwaresubhead">{{ obj.subtitile }}</h6>
            <p>{{ obj.caption }}</p>
            <p><a :href="`../${obj.link}`">Read More</a></p>
          </div>
        </div>
      </div>

      <!-- <div class="pt-4 text-center">
        <Button :text="buttontText" />
      </div> -->
    </div>
  </section>
</template>
<script>
// import Button from "@/components/Button.vue";
import Image from "@/components/Image.vue";
export default {
  components: {
    Image,
    // Button,
  },
  data: () => ({
    buttontText: "View all",
    featureareaJSON: [
      {
        path: "Airline.jpg",
        category: "Analytics",
        header: "Airline Traffic Analytics",
        link: "blogs/subscription-revenue-management",
        caption:
          "International airline traffic analytics dashboard provides a quick look at KPI’s related to aviation market in Australia. Metrics include key growth parameters and long term patterns related to Passengers & Cargo arriving from and departing to various destinations across the world.",
      },
      {
        path: "Time-Series.jpg",
        category: "Analytics",
        link: "time-series",
        header: "Time Series Analysis – International Air Traffic",
        caption:
          "Time series analysis, a popular and effective tool to analyze historical data, identify patterns and predict the future trends. “Air Passengers” is a popular measure considered in many research articles pertaining to time series analysis and validating effectiveness of prediction output.",
      },
      {
        path: "Airport.jpg",
        category: "Analytics",
        link: "airport-traffic",
        header: "Airport Traffic Movement Analysis",
        caption:
          "Air Traffic is driven by demand for passengers as well as cargo, but the majority of revenue generated by airlines are through transporting passengers from source to destination. This demo looks at traffic patterns on annual basis for operating airports in Australia.",
      },
    ],
  }),
};
</script>
<style scoped>
span.dot {
  padding: 0px 0px 0px 10px;
}
.services .icon-box:hover {
  background: #f7f9fd;
  cursor: pointer;
  border-color: #0880e8;
}
img.serviceimage {
  width: 100%;
  padding-bottom: 15px;
  border-radius: 15px;
}
section#features {
  padding: 30px;
}
.services .icon-box {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 15px;
  padding: 0px 0px 20px 0px;
  border: 1px solid #fff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
}
.services .icon-box h4 {
  font-weight: 500;
  font-size: 18px;
  padding: 0px 20px;
  color: #0880e8;
  line-height: 1.5em;
}

.services .icon-box a {
  color: #0880e8;
}
.services .icon-box p {
  font-size: 16px;
  padding: 0px 20px;
}
@media (max-width: 998px) and (min-width: 0px) {
  section#features {
    padding: 40px;
  }
}
.category {
  background: #f4f4f4;
  padding: 5px 10px;
}
.readtime {
  padding: 5px 10px;
}
</style>
